// Location SEO landing pages — DRY content driven by slug.
export const LOCATIONS = {
  "hospitality-business-consultant": {
    slug: "hospitality-business-consultant",
    title: "Hospitality Business Consultant",
    metaTitle: "Hospitality Business Consultant UK | Optimum Hospitality Solutions",
    metaDescription:
      "Hospitality business consulting for UK hotel owners, multi site operators and hospitality investors. Practical operating support that lifts performance, profitability and guest experience.",
    h1: "Hospitality Business Consultant.",
    overline: "Hospitality Business Consultancy · UK",
    intro:
      "Hospitality business consulting for owners, operators and investors who need an experienced operating perspective on the asset, the team and the P&L. We work alongside the property, not at arm's length, with the discipline of an operator who has run the business themselves.",
    region: { name: "United Kingdom", country: "United Kingdom", geo: { latitude: 54.0, longitude: -2.0 } },
    contextPoints: [
      "Owners and operators looking for a structured operating view of the asset, beyond the brand or operating company's own reporting.",
      "Investors and asset managers needing an independent diagnostic on a property before refinancing, acquisition or disposal.",
      "Operating teams seeking practical, non political support to lift specific lines of the P&L.",
      "Boards and shareholders wanting a credible operating story to underwrite the next phase of growth.",
    ],
    whyHere: [
      "Engagements scoped against the asset and the brief, not against billable hours.",
      "Independent of any operating brand or management company, with no operating company conflict.",
      "A single point of accountability across diagnostic, recommendation and implementation phases.",
      "UK wide coverage, with meaningful time spent in the property at every engagement.",
    ],
    services: [
      "hospitality-business-performance-improvement",
      "hotel-operations-consultancy",
      "hospitality-audits-operational-reviews",
      "multi-site-hospitality-performance-support",
    ],
    faqs: [
      { q: "What kind of brief do you typically take on?", a: "Operating diagnostics, performance improvement, audits, multi site standardisation, interim management and pre-opening setup. Engagements are sized against the brief, from a three week audit through to a twelve month advisory partnership." },
      { q: "Do you work with investors and asset managers directly?", a: "Yes. A significant share of our engagements come from the owner or asset manager side rather than the operating team. We can be scoped confidentially around an acquisition, refinancing or disposal." },
      { q: "How do you measure success on an engagement?", a: "Each engagement opens with a written baseline and a small set of measurable outcomes — typically labour cost, food and beverage margin, guest scores and GOP movement. Progress is reviewed monthly against the baseline." },
    ],
  },

  "hotel-consultancy-london": {
    slug: "hotel-consultancy-london",
    title: "Hotel Operations Consultancy in London",
    metaTitle: "Hotel Operations Consultant London | Optimum Hospitality Solutions",
    metaDescription:
      "London hotel operations consultancy for independent hotels, boutique groups, aparthotels and serviced accommodation operators. Practical, hands on work in the property, led by Sidney Adams.",
    h1: "Hotel Operations Consultancy in London.",
    overline: "Hospitality Consultancy · London",
    intro:
      "Operational consultancy for London hotel owners, general managers and operations directors. We work inside the property to lift performance, productivity and guest experience, with the discipline of an operator who has run a London property through busy seasons, soft markets and brand transitions.",
    region: { name: "London", country: "United Kingdom", geo: { latitude: 51.5074, longitude: -0.1278 } },
    contextPoints: [
      "A London market that absorbs operational mistakes less forgivingly than most.",
      "Labour costs and recruitment pressures that need a sharper operating model, not just a bigger rota.",
      "Guest expectations set by some of the best hotels in the world, in the same square mile as your property.",
      "Owners and asset managers expecting institutional reporting from independent operations.",
    ],
    whyHere: [
      "Based in London with the practice's registered office in Walthamstow, E17.",
      "Working with hotel owners, boutique groups, aparthotels and serviced apartment operators across Central, City, West End and Greater London.",
      "Bandwidth deliberately kept small so each engagement gets meaningful time in the property.",
      "A practice positioned around the operating layer, not brand or operating company politics.",
    ],
    services: [
      "hotel-operations-consultancy",
      "labour-productivity-cost-optimisation",
      "guest-experience-enhancement",
      "hospitality-audits-operational-reviews",
    ],
    faqs: [
      { q: "Do you only work with London hotels?", a: "No. London is our home market and where the practice is based, but we work across the UK. Many engagements involve travel to properties outside the M25." },
      { q: "What size of London hotel do you typically support?", a: "Independent hotels and boutique groups from 25 keys upwards. Aparthotels and serviced apartment portfolios from 40 units upwards. Asset values typically £5M to £100M." },
      { q: "How quickly can a London engagement start?", a: "Discovery call within a week. Most paid engagements start within two to four weeks of brief sign off." },
    ],
  },

  "hospitality-consultant-uk": {
    slug: "hospitality-consultant-uk",
    title: "Hospitality Consultancy across the United Kingdom",
    metaTitle: "Hospitality Consultant UK | Optimum Hospitality Solutions",
    metaDescription:
      "UK wide hospitality consultancy for hotel owners, multi site operators and hospitality groups. Operational performance, labour productivity, guest experience and audits, delivered with meaningful time in the property.",
    h1: "Hospitality Consultancy across the United Kingdom.",
    overline: "Hospitality Consultancy · UK Wide",
    intro:
      "Nationwide consultancy for independent hotels, hospitality groups, aparthotel operators and serviced accommodation businesses across England, Scotland, Wales and Northern Ireland. Practical operating work, scoped tightly, delivered in the property where it matters.",
    region: { name: "United Kingdom", country: "United Kingdom", geo: { latitude: 54.0, longitude: -2.0 } },
    contextPoints: [
      "Regional UK hotels facing labour, cost and rate environments that vary widely between cities and counties.",
      "Multi site operators trying to standardise the performance layer without flattening local identity.",
      "Boutique and country house hotels balancing institutional discipline with the craft of independent hospitality.",
      "Aparthotel and serviced apartment operators scaling beyond the model that worked for the first five sites.",
    ],
    whyHere: [
      "Based in London, working with hotel owners and operators across the whole of the UK.",
      "Engagements scoped around time in the property, not remote advisory only.",
      "A single point of accountability across single asset and portfolio briefs.",
      "Independent of any operating brand or management company.",
    ],
    services: [
      "hotel-operations-consultancy",
      "hospitality-business-performance-improvement",
      "multi-site-hospitality-performance-support",
      "interim-hospitality-management-support",
    ],
    faqs: [
      { q: "Which UK regions do you cover?", a: "All four nations of the UK. Most engagements are scoped around time in the property, with the cadence agreed at brief sign off. Travel and accommodation are billed at cost, separately from the engagement fee." },
      { q: "Do you support portfolios with sites outside London?", a: "Yes. Multi site portfolios are supported through a phased rollout, typically two to three assets in pilot before scaling." },
      { q: "Are engagements priced differently outside London?", a: "No. Engagements are priced against the property and the brief, not the postcode. Reasonable travel costs are billed separately." },
    ],
  },
};

export const LOCATION_SLUGS = Object.keys(LOCATIONS);
